module.exports = __webpack_public_path__ + "static/img/879_phase_function_Paper_PointsHejduk_Prediction.e1df39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/879_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nQ19
// module chunks = 0